var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.586.333c.65 0 1.243.367 1.533.948l.511 1.022a.572.572 0 00.512.316h6.15c.947 0 1.715.767 1.715 1.714v8c0 .947-.768 1.715-1.715 1.715H1.723a1.714 1.714 0 01-1.715-1.715V2.048C.007 1.1.774.333 1.72.333h3.865z",
    fill: "#6F6F6F"
  })));
}
export default SvgIconFolder;